import {useQuery} from '@tanstack/react-query'
import React, {useEffect} from 'react'
import {QueryCacheKeys} from '../../QueryKey'
import {getPostDetail} from '../../../apis/post/getPostDetail'

const useQueryPostDetail = (id?: string) => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.post.getPostDetail(id),
        queryFn: async () => {
            const {data} = await getPostDetail(id)
            return data
        },
        refetchOnWindowFocus: false,
    })

    useEffect(() => {
        refetch()
    }, [])

    return {data, refresh: refetch, isLoading}
}

export default useQueryPostDetail
